export const blockIconsNotificationSyncProblem = (
	<span className='material-symbols-outlined'>sync_problem</span>
);
